module.exports = __webpack_public_path__ + "media/images/logo-white-92cc539d97ae85d2f5e1401ecf2c612a.png";